import React from 'react';
import { useCapabilities } from '../../hooks/useCapabilities';

const CapabilityGate = ({ capability, children, fallback = null }) => {
    const { hasCapability } = useCapabilities();
    const isAllowed = hasCapability(capability);

    console.log(`DEBUG [CapabilityGate] Checking: ${capability}, Allowed: ${isAllowed}`);

    if (!isAllowed) {
        return fallback;
    }

    return <>{children}</>;
};

export default CapabilityGate;
